import React from 'react';
import { StyledBurger } from './BurgerBtn.style';
export var BurgerBtn = function (_a) {
    var opened = _a.opened, onClick = _a.onClick;
    return (React.createElement(StyledBurger, { "aria-label": "menu", "aria-expanded": opened, opened: opened, onClick: onClick },
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null)));
};
